export const DEFAULT_LOCALE = 'en';
export const ISO_LOCALE = {
    [DEFAULT_LOCALE]: 'en_EN',
    'fr': 'fr_FR',
    'es': 'es_ES'
};
